






















import Vue from "vue";
import { GlobalStatusEnum, globalStatusEnumLabel } from "@/model/data/status/GlobalStatusEnum";
import { InstallationPeripheral } from "@/model/data/InstallationPeripheral";
import { peripheralTypeEnumLabel } from "@/model/data/enums/PeripheralTypeEnum";

export default Vue.extend({
    data() {
        return { GlobalStatusEnum };
    },
    props: {
        peripheral: { type: Object as () => InstallationPeripheral },
    },
    computed: {
        object() {
            return {
                type: this.peripheral.type,
                globalStatus: this.$t(this.globalStatusEnumLabel(this.peripheral.status.globalStatus)),
                error: this.peripheral.extension,
            };
        },
        keys() {
            return [
                {
                    name: "type",
                    i18nName: "common.type",
                    i18nValue: this.peripheralTypeEnumLabel,
                },
                {
                    name: "globalStatus",
                    i18nName: "device_status.global_status",
                    i18nValue: this.globalStatusEnumLabel,
                },
                { name: "error", i18nName: "common.error" },
            ];
        },
    },
    methods: {
        peripheralTypeEnumLabel,
        globalStatusEnumLabel,
        getColorFromGlobalStatus(key: { name: string; i18nName: string; i18nValue: string }): string {
            if (key.name == "globalStatus") {
                let status: GlobalStatusEnum = this.peripheral[key.name];
                switch (status) {
                    case GlobalStatusEnum.Ok:
                        return "success--text";
                    case GlobalStatusEnum.Ko:
                        return "error--text";
                    case GlobalStatusEnum.Unknown:
                        return "";
                }
            }
            return "";
        },
    },
});
